export const GroupByOptionsEnum = {
  SITE: 0,
  ORDER: 1,
  ITEMCODE: 2,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/OpenOrderReportEnum.js